/**
 * Fonctions utilitaires pour les trimestres
 */
export const getQuarterFromMonth = (month) => {
  if (month >= 1 && month <= 3) return 'Q1';
  if (month >= 4 && month <= 6) return 'Q2';
  if (month >= 7 && month <= 9) return 'Q3';
  return 'Q4';
};

export const createQuarterlyData = () => ({
  Q1: 0, Q2: 0, Q3: 0, Q4: 0, ANNUEL: 0
});

/** Arrondi à 2 décimales pour éviter les erreurs de virgule flottante */
export const round2 = (val) => Math.round(val * 100) / 100;
